<template>
    <b-card class="mb-1" :title="$t('Component(ResearchReviewProcess):document-information')">
        <b-row>
            <b-col md="6">
                <b-form-group :label="$t('Component(Grid):column-type')">
                    <v-select
                        v-model="localValue.type"
                        :options="documentTypeOptions"
                        label="label"
                        :reduce="option => option.id"
                        :append-to-body="true"
                    />
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group :label="$t('Component(Label):date')">
                    <b-form-datepicker
                        v-model="localValue.date"
                        :date-format-options="$store.state.component.datePicker.format"
                        :locale="$store.state.component.datePicker.locale"
                    />
                </b-form-group>
            </b-col>
        </b-row>

        <b-form-group :label="$t('Component(Grid):column-title')">
            <b-form-input v-model="localValue.title"/>
        </b-form-group>

        <b-form-group :label="$t('Component(Grid):column-relevance')" class="mb-0">
            <v-select
                v-model="localValue.relevance"
                :options="relevanceOptions"
                label="label"
                :reduce="option => option.id"
                :append-to-body="true"
            />
        </b-form-group>
    </b-card>
</template>

<script>
import {BCard, BRow, BCol, BFormGroup, BFormInput, BFormDatepicker} from 'bootstrap-vue'
import {VerificationDocumentType} from '@/libs/product'
import vSelect from 'vue-select'

function clone(value) {
    return JSON.parse(JSON.stringify(value || {}))
}

function isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}

function normalize(value) {
    const normalized = clone(value)

    if (!Object.prototype.hasOwnProperty.call(normalized, 'type')) {
        normalized.type = null
    }
    if (!Object.prototype.hasOwnProperty.call(normalized, 'date')) {
        normalized.date = null
    }
    if (!Object.prototype.hasOwnProperty.call(normalized, 'title')) {
        normalized.title = null
    }
    if (!Object.prototype.hasOwnProperty.call(normalized, 'relevance')) {
        normalized.relevance = null
    }

    return normalized
}

export default {
    name: 'DocumentInformationSection',
    components: {
        BCard,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormDatepicker,
        vSelect,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            localValue: normalize(this.value),
        }
    },
    computed: {
        documentTypeOptions() {
            const options = [
                {id: null, label: '-'},
                ...VerificationDocumentType
                    .all()
                    .map(type => ({
                        id: type,
                        label: this.$t(VerificationDocumentType.translationKey(type)),
                    })),
            ]

            const current = this.localValue ? this.localValue.type : null
            if (current && !options.find(option => option.id === current)) {
                options.push({id: current, label: current})
            }

            return options
        },
        relevanceOptions() {
            const options = [
                {id: null, label: '-'},
                {id: 'relevant', label: this.$t('Component(ResearchReviewProcessEnum):relevance-relevant')},
                {id: 'uncertain', label: this.$t('Component(ResearchReviewProcessEnum):relevance-uncertain')},
                {id: 'irrelevant', label: this.$t('Component(ResearchReviewProcessEnum):relevance-irrelevant')},
            ]

            const current = this.localValue ? this.localValue.relevance : null
            if (current && !options.find(option => option.id === current)) {
                options.push({
                    id: current,
                    label: this.$t('Component(ResearchReviewProcessEnum):relevance-' + current),
                })
            }

            return options
        },
    },
    watch: {
        value: {
            deep: true,
            handler(newValue) {
                const normalized = normalize(newValue)
                if (isEqual(normalized, this.localValue)) {
                    return
                }

                this.localValue = normalized
            },
        },
        localValue: {
            deep: true,
            handler(newValue) {
                const emitted = clone(newValue)
                const current = normalize(this.value)

                if (isEqual(emitted, current)) {
                    return
                }

                this.$emit('input', emitted)
            },
        },
    },
}
</script>
